import React from "react";
import {
    List,
    Datagrid,
    Edit,
    Create,
    TextField,
    EditButton,
    TextInput,
    Filter,
} from "react-admin";
import BaseForm from "../baseForm";

const form = <BaseForm fields={
    {name: '', name_vi: '', summary: '', summary_vi: '', author: '', price: 0, sale_price: 0, order: 0}
} selections={
    {category_id: 'book-all-category'}
} editors={
    {description: '', description_vi: '', maintenance: '', maintenance_vi: '', }
} files={
    {demo_file: '', demo_file_vi: ''}
} gallery={
    {images: ''}
} checkboxes={
    {is_trending: false, is_new: false, is_show_banner: false}
}/>

const BookFilter = (props) => (
    <Filter {...props}>
        <TextInput source="name" label="name" alwaysOn/>
    </Filter>
);

export const BookList = props => (
    <List {...props} filters={<BookFilter/>} filter={{is_published: true}}>
        <Datagrid>
            <TextField source="id"/>
            <TextField source="name"/>
            <TextField source="name_vi"/>
            <TextField source="order"/>
            <TextField source="category_name"/>
            <EditButton basePath="/book"/>
        </Datagrid>
    </List>
);

export const BookEdit = props => (
    <Edit title='Update' {...props}>
        {form}
    </Edit>
);

export const BookCreate = props => (
    <Create title="Create" {...props}>
        {form}
    </Create>
);
